import { Shape } from './Shape.js';
import { fabric } from 'fabric';
import { ShapeAction } from './ShapeFactory.js';


export const PIN_ICON_PATH_DATA =
    'M44.5,15c0-8.271-6.729-15-15-15s-15,6.729-15,15c0,7.934,6.195,14.431,14,14.949V58c0,0.553,0.448,1,1,1s1-0.447,1-1  V29.949C38.305,29.431,44.5,22.934,44.5,15z M24.5,15c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S26.706,15,24.5,15z';

var defaultProps = {
    stroke: 'red',
    fill: 'red',
    width: 200,
    height: 200,
    scaleX: 1.2,
    scaleY: 1.2
};

class PinPointer extends Shape {
    constructor(props) {
        super(props);
        this.pinShape = null;
        this.doubleClicked = props.doubleClicked;
    }
    draw(props) {
        //working while snapsot
        this.newProps = {
            ...defaultProps,
            ...props
        };

        //Forcing both color to be similar
        props.fill = props.stroke;
        this.newProps.fill = this.newProps.stroke;

        if (props.action !== ShapeAction.START) {
            let canvasObject = new fabric.Path(PIN_ICON_PATH_DATA, {
                ...this.newProps
            });

            canvasObject.setControlsVisibility({
                mt: false,
                mb: false,
                ml: false,
                mr: false
            });
            super.draw(canvasObject);
            return;
        }
        const events = {
            onCanvasMouseDown: this.onMouseDown.bind(this),
            onCanvasMouseUp: this.onMouseUp.bind(this)
        };

        this.drawingCanvas.registerEvents(events);
    }
    onMouseDown(points) {
        var _this = this;
        const [x, y] = points;
        this.newProps = { ...this.newProps, left: x, top: y };

        this.pinShape = new fabric.Path(PIN_ICON_PATH_DATA, {
            ..._this.newProps
        });
        this.pinShape.uuid = this.newProps.uuid;
        this.pinShape.uuid_parent = this.newProps.uuid_parent;

        this.pinShape.setControlsVisibility({
            mt: false, // middle top disable
            mb: false, // midle bottom
            ml: false,
            mr: false
        });
        this.drawingCanvas.addAsActiveShape(this.pinShape);
    }

    onMouseUp() {
        this.drawingCanvas.removeEvents();
        this.newProps.action = ShapeAction.ADD;
        super.toFebricObject(this.pinShape);
        if (this.onDrawCompleted) {
            this.onDrawCompleted({
                showPlaceholder: this.pinShape.showPlaceholder,
                ...this.newProps,
                ...this.pinShape.toObject()
            });
        }
    }
}

export { PinPointer };
